// extracted by mini-css-extract-plugin
export default {"downloadIcon":"ResumeDownloadButton_downloadIcon__YsHfK"};